module.exports = __webpack_public_path__ + "static/media/complete_profile_thumbnail.313bb72e.png";